import { render, staticRenderFns } from "./FaRegSquare.vue?vue&type=template&id=7ea879b2"
import script from "./FaRegSquare.vue?vue&type=script&lang=ts"
export * from "./FaRegSquare.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports